import { render, staticRenderFns } from "./UpcomingClass.vue?vue&type=template&id=40d1b2b2&"
import script from "./UpcomingClass.vue?vue&type=script&lang=js&"
export * from "./UpcomingClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports